// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import SidebarEtd from '../../../shared/components/SidebarEtd';
// import HeaderEtd from '../../../shared/components/HeaderEtd';
// import { Modal, Button } from "react-bootstrap";
// import ReactToPrint from "react-to-print";
// import { PDFExport } from "@progress/kendo-react-pdf";
// // import ComponentToPrintBill from "./printOut/bill/Bill";
// // import ComponentToPrintReceipt from "./printOut/bill/Receipt";
// import { FaPrint } from "react-icons/fa";
// import Pagination from "react-js-pagination";
// import {
//   setAppIdSession,
//   getSysId,
//   getUsername,
//   getStation,
//   url,
//   setOna,
//   getAppId,
//   remSessionNextPage,
//   getAccessorId,
//   getTerritory,
// } from '../../../shared/utils/storage';

// function MyModalBill(props) {
//   remSessionNextPage();
//   const clickedAppID = props.appIDProp;
//   const pdfExportComponent = React.useRef(null);
//   const ref = useRef(null);

//   return (
//     <Modal
//       {...props}
//       aria-labelledby="contained-modal-title-vcenter"
//       className="modal-dialog modal-800"
//     >
//       <Modal.Header closeButton>
//         <Modal.Title id="contained-modal-title-vcenter">
//           Using Grid in Modal
//         </Modal.Title>
//       </Modal.Header>
//       <Modal.Body className="show-grid">
//         {/* <PDFExport forcePageBreak=".page-break" ref={pdfExportComponent}>
//           <div ref={ref}>
//             <ComponentToPrintBill props={clickedAppID} />
//           </div>
//         </PDFExport> */}
//       </Modal.Body>
//       <Modal.Footer>
//         <ReactToPrint
//           content={() => ref.current}
//           trigger={() => (
//             <button
//               type="submit"
//               className="btn pull-right btn-info"
//               name="SaveNext"
//             >
//               Print | <FaPrint />
//             </button>
//           )}
//         />
//         <Button onClick={props.onHide}>Close</Button>
//       </Modal.Footer>
//     </Modal>
//   );
// }

// function MyModalReceipt(props) {
//   const refreshPage = () => {
//     window.location.reload();
//   };

//   const clickedAppID = props.appIDProp;
//   console.log("props", props);
//   const pdfExportComponent = React.useRef(null);
//   const ref = useRef(null);
//   return (
//     <Modal
//       {...props}
//       aria-labelledby="contained-modal-title-vcenter"
//       className="modal-dialog modal-800"
//     >
//       <Modal.Header closeButton>
//         <Modal.Title id="contained-modal-title-vcenter">
//           Using Grid in Modal
//         </Modal.Title>
//       </Modal.Header>
//       <Modal.Body className="show-grid">
//         {/* <PDFExport forcePageBreak=".page-break" ref={pdfExportComponent}>
//           <div ref={ref}>
//             <ComponentToPrintReceipt props={clickedAppID} />
//           </div>
//         </PDFExport> */}
//       </Modal.Body>
//       <Modal.Footer>
//         <ReactToPrint
//           content={() => ref.current}
//           trigger={() => (
//             <button
//               type="submit"
//               className="btn pull-right btn-info"
//               name="SaveNext"
//               onClick={refreshPage}
//             >
//               Print | <FaPrint />
//             </button>
//           )}
//         />
//         <Button onClick={props.onHide}>Close</Button>
//       </Modal.Footer>
//     </Modal>
//   );
// }

// function Accountant() {
//   const [etd, setEtd] = useState({});
//   let appId = etd.AppId;
//   const [error, seterror] = useState();
//   const [Stage, setStage] = useState({
//     Stg: "4",
//     StationID: getStation(),
//     SystemID: getSysId(),
//     AccessorId: getAccessorId(),
//     CreatedBy: getUsername(),
//   });

//   function getNewListPool() {
//     axios
//       .post(url() + "etd_int_applicationpool", Stage)
//       .then((res) => {
//         if (res.data.code == 1) {
//           setViewApplications(res.data.data);
//         }
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//     axios
//       .post(url() + "etd_int_inprogressapplications", Stage)
//       .then((res) => {
//         setInprogressapp(res.data.data[0]);
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   }

//   useEffect(() => {
//     getApplicationPool()
//     axios
//       .post(url() + "etd_int_inprogressapplications", Stage)
//       .then((res) => {
//         setInprogressapp(res.data.data[0]);
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   }, []);


//  const getApplicationPool = ()=>{
//   axios
//   .post(url() + "etd_int_applicationpool", Stage)
//   .then((res) => {
//     if (res.data.code == 1) {
//       setViewApplications(res.data.data);

//     }
//   })
//   .catch((err) => {
//     console.log(err);
//   });
//   }

//   const [Inprogressapp, setInprogressapp] = useState([]);
//   const [ViewApplications, setViewApplications] = useState([]);
//   const [show, setShow] = useState(false);

//   const [accountbills, setaccountbills] = useState({
//     StageID: "",
//     territory: getTerritory(),
//     StationID: getStation(),
//     SystemID: getSysId(),
//     UserName: getUsername(),
//     ApplicationID: "",
//     controlnumber: "",
//     AccessorId: getAccessorId(),
//     CreatedBy: getUsername(),
//   });

//   function rebill(Application) {
//     accountbills.ApplicationID = Application;
//     axios
//       .post(url() + "etd_int_rebillcontrolnumber", accountbills)
//       .then((res) => {
//         if (res.data.code == 1) {
//           alert("Application get Control Number" + res.data.ControlNumber);
//           // window.location.reload();
//         } else {
//           alert(res.data.message);
//           window.location.reload();
//         }
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   }

//   function printBill(Application) {
//     accountbills.ApplicationID = Application;
//     setShow(true);
//     setOna(1);
//   }

//   async function printReceipt(Application) {
//     accountbills.StageID = "7";
//     accountbills.ApplicationID = Application;
//     setOna(1);
//     setAppIdSession(Application);
//     setShow(true);
//     axios
//       .post(url() + "etd_updatestageinternal", accountbills)
//       .then((res) => {
//         if (res.data.code == 1) {
//         } else {
//           alert(res.data.message);
//           window.location.reload();
//         }
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   }

//   async function checkPayment(ControlNumber) {
//     accountbills.StageID = "7";
//     accountbills.controlnumber = ControlNumber;
//     setOna(1);
//     // setAppIdSession(Application);
//     setShow(true);
//     axios
//       .post(url() + "etd_int_payment", accountbills)
//       .then((res) => {
//         if (res.data.code == 1) {
//           alert(res.data.message);
//           getApplicationPool()
//           // window.location.reload();
//         } else {
//           alert(res.data.message);
//           // window.location.reload();
//         }
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   }

//   //react-js paginate function zake
//   const AdminPerPage = 3;
//   const [activePage, setCurrentPage] = useState(1);
//   const [pageCount, setPageCount] = useState(0);

//   const indexOfLastTodo = activePage * AdminPerPage;
//   const indexOfFirstTodo = indexOfLastTodo - AdminPerPage;
//   const currentAdmin = ViewApplications.slice(
//     indexOfFirstTodo,
//     indexOfLastTodo
//   ); //napitisha migrant nlioiset juu

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//     setPageCount(Math.ceil(ViewApplications.length / AdminPerPage)); //napitisha migrant nlioiset juu
//   };

//   //get application id and set to applicationid state for props in bill component
//   const viewBillDetails = (applicationID) => {
//     setClickedAppID(applicationID);
//     setmodalShowBillReceipt(true);
//     // window.location.reload();
//   };

//   //get application id and set to applicationid state for props in bill component
//   const viewBillDetails2 = (applicationID) => {
//     setClickedAppID(applicationID);
//     setModalShowBill(true);
//   };

//   //get application id and set to applicationid state for props
//   const viewReceipDetails = (applicationID) => {
//     printReceipt(applicationID)
//       .then(() => {
//         setModalShowReceipt(true);
//         // window.location.reload(false);
//       })
//       .catch((error) => {
//         console.log(error);
//         alert("something went wrong please try again");
//       });
//     setClickedAppID(applicationID);
//   };

//   const [modalShowBill, setModalShowBill] = useState(false);
//   const [modalShowBillReceipt, setmodalShowBillReceipt] = useState(false);
//   const [modalShowReceipt, setModalShowReceipt] = useState(false);
//   const [clickedAppID, setClickedAppID] = useState("");

//   // const [loading, setLoading] = useState(false);
//   const styles = {
//     h4: {
//       color: "#850505",
//       textTransform: "uppercase",
//     },
//   };

//   return (
//     <>
//       <HeaderEtd />
//       <body className="">
//         <div className="wrapper">
//           <SidebarEtd />
//           <div className="main-panel">
//             <div className="content4">
//               <div className="card-body">
//                 <h2 style={{ color: "#c2c2c2" }}>
//                   <i>Accountant</i>
//                 </h2>
//               </div>
//               {/*---------------App. Progress------------*/}
//               <div className="col-md-12">
//                 <div className="card2">
//                   <div className="card-body">
//                     <div className="row">
//                       <div
//                         className="collapse barNav-collapse barNav-1"
//                         style={{ marginTop: "0px" }}
//                       >
//                         <b style={{ color: "green" }}>
//                           <u>Applications In-progres:</u>
//                           &emsp;&emsp;
//                         </b>
//                         Pending Assessment:&nbsp; | (
//                         <text style={styles.h4}>
//                           {Inprogressapp.Assessment}
//                         </text>
//                         ); &emsp; Pending Approval:&nbsp; | (
//                         <text style={styles.h4}>{Inprogressapp.Approval}</text>
//                         ); &emsp; Pending Payment:&nbsp; | (
//                         <text style={styles.h4}>{Inprogressapp.Payment}</text>
//                         ); &emsp; Ready for Print:&nbsp; | (
//                         <text style={styles.h4}>{Inprogressapp.Printing}</text>
//                         );
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               {/*-----------------------------------------*/}

//               <div className="col-md-12">
//                 <div className="card2">
//                   <div className="card-body">
//                     <div className="container">
//                       {error && (
//                         <p style={{ color: "red" }}>
//                           <center>{error}</center>
//                         </p>
//                       )}
//                       <table
//                         id="example"
//                         className="table table-striped table-bordered"
//                         style={{ width: "100%" }}
//                       >
//                         <thead>
//                           <tr>
//                             <th style={{ width: "10%" }}>
//                               <b>ApplicationID</b>
//                             </th>
//                             <th style={{ width: "27%" }}>
//                               <b>Full Name</b>
//                             </th>
//                             <th style={{ width: "15%" }}>
//                               <b>Occupation</b>
//                             </th>
//                             <th style={{ width: "13%" }}>
//                               <b>Control Number</b>
//                             </th>
//                             <th style={{ width: "17%" }}>
//                               <b>Status</b>
//                             </th>
//                             <th style={{ width: "18%" }}>
//                               <b>Action</b>
//                             </th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {ViewApplications.map((obj) => (
//                             <tr>
//                               <td>
//                                 <h4 style={styles.h4}>{obj.ApplicationId}</h4>
//                               </td>
//                               <td>
//                                 <h4 style={styles.h4}>{obj.FullName}</h4>
//                               </td>
//                               <td>
//                                 <h4 style={styles.h4}>{obj.Occupation}</h4>
//                               </td>
//                               <td>
//                                 <h4 style={styles.h4}>{obj.ControlNumber}</h4>
//                               </td>
//                               <td>
//                                 <h4 style={styles.h4}>{obj.StageName}</h4>
//                               </td>
//                               <td>
//                                 {obj.StageId == 3 ? (
//                                   <>
//                                     <button
//                                       variant="primary"
//                                       onClick={() => rebill(obj.ApplicationId)}
//                                       type="submit"
//                                       className="btn-primary btn-sm"
//                                       name="submit"
//                                       value="0002033"
//                                     >
//                                       Rebill
//                                     </button>
//                                   </>
//                                 ) : (
//                                   ""
//                                 )}
//                                 {obj.StageId == 4 ? (
//                                   <>
//                                     <button
//                                       variant="primary"
//                                       onClick={() =>
//                                         // printBill(obj.ApplicationId)
//                                         viewBillDetails(obj?.ApplicationId)
//                                       }
//                                       type="submit"
//                                       className="btn-success btn-sm"
//                                       name="submit"
//                                       value="0002033"
//                                     >
//                                       Print Bill
//                                     </button>

//                                     <MyModalBill
//                                       show={modalShowBillReceipt}
//                                       onHide={() =>
//                                         setmodalShowBillReceipt(false)
//                                       }
//                                       appIDProp={clickedAppID}
//                                     />
//                                   </>
//                                 ) : (
//                                   ""
//                                 )}
//                                 {obj.StageId == 5 ? (
//                                   <>
//                                     <button
//                                       variant="primary"
//                                       onClick={() =>
//                                         checkPayment(obj?.ControlNumber)
//                                       }
//                                       type="submit"
//                                       className="btn-primary btn-sm"
//                                       name="submit"
//                                       value="0002033"
//                                     >
//                                       Check Payment
//                                     </button>

//                                     <MyModalBill
//                                       show={modalShowBill}
//                                       onHide={() =>
//                                         checkPayment(obj?.ApplicationId)
//                                       }
//                                     />
//                                   </>
//                                 ) : (
//                                   ""
//                                 )}
//                                 {obj.StageId == 6 ? (
//                                   <>
//                                     <button
//                                       variant="primary"
//                                       onClick={() =>
//                                         viewReceipDetails(obj.ApplicationId)
//                                       }
//                                       type="submit"
//                                       className="btn-success btn-sm"
//                                       name="submit"
//                                       value="0002033"
//                                     >
//                                       Print Receipt
//                                     </button>

//                                     <MyModalReceipt
//                                       show={modalShowReceipt}
//                                       onHide={() => setModalShowReceipt(false)}
//                                       appIDProp={clickedAppID}
//                                     />
//                                   </>
//                                 ) : (
//                                   ""
//                                 )}
//                               </td>
//                             </tr>
//                           ))}
//                         </tbody>
//                         <tfoot>
//                           <tr>
//                             <th>ApplicationID</th>
//                             <th>Full Name</th>
//                             <th>Occupation</th>
//                             <th>Application Type</th>
//                             <th>Status</th>
//                             <th>Action</th>
//                           </tr>
//                         </tfoot>
//                       </table>
//                       <div className="pagination pull-left">
//                         <i style={{ color: "grey" }}>Page: {activePage}</i>
//                       </div>
//                       <div className="pagination pull-right">
//                         <Pagination
//                           activePage={activePage}
//                           itemsCountPerPage={3}
//                           totalItemsCount={ViewApplications.length}
//                           pageRangeDisplayed={3}
//                           onChange={handlePageChange}
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </body>
//     </>
//   );
// }

// export default Accountant;

const Accountant = () => <div></div>;
export default Accountant;
